import { Component, OnInit } from '@angular/core';
import { trigger, style, animate, transition, state } from '@angular/animations';
import { City, Departaments } from '../../../shared/models/missingdata.model';
import { CityService } from '../../../shared/_services/city.service';

@Component({
  selector: 'app-table-cities',
  templateUrl: './table-cities.component.html',
  styleUrls: ['./table-cities.component.css'],
  animations: [
    trigger('EnterLeave', [
      state('flyin', style({
        opacity: 1,
        transform: 'translateX(0%)'
      })),
      transition(':enter', [
        style({
          opacity: 0.2,
          transform: 'translateX(-100%)',
        }),
        animate('0.3s 300ms ease-in')
      ]),
      transition(':leave', [
        animate('0.5s ease-out', style({
          transform: 'translateX(100%)'
        }))
      ])
    ])
  ]
})
export class TableCitiesComponent implements OnInit {

  SearchTerm: string;
  List: City[];
  List2: Departaments[];
  NewElement: City = new City();
  saveElement: City[] = [];
  FormNew = false;
  error: string;
  message: string;
  idSelected: number = -1;

  constructor(
    private cityService: CityService
  ) { }

  ngOnInit() {
    this.cityService.getdepartments()
      .subscribe((res: Departaments[]) => {
        this.List2 = res;
        this.cityService.getCities()
          .subscribe((lista: City[]) => {
            this.List = lista;
          }, err => {
              this.error = err;
              setTimeout(() => {
                this.cleanMessage();
              }, 7000);
          })
      }, err => {
          this.error = err;
          setTimeout(() => {
            this.cleanMessage();
          }, 7000);
      });
  }

  cleanMessage() {
    this.message = undefined;
    this.error = undefined;
    this.saveElement = [];
  }

  onKeyUp(value) {
    this.SearchTerm = value;
  }

  toggleNew() {
    this.NewElement = new City;
    this.FormNew = !this.FormNew;
  }

  add() {
    this.cleanMessage();
    if (this.NewElement) {
      this.NewElement.fkIdDepartment = this.idSelected;
      this.saveElement.push(this.NewElement);
      this.cityService.saveCities(this.saveElement)
        .subscribe(res => {
          this.List.push(this.NewElement);
          this.List.sort((a, b) => a.idCity < b.idCity ? -1 : a.idCity > b.idCity ? 1 : 0);
          this.FormNew = false;
          this.message = "Elemento agregado correctamente";
        }, err => this.error = err
        )
    }
  }

  changeValue(idCity: any) {
    this.cleanMessage();
    let name = "[date-city ='" + idCity + "']";
    document.querySelectorAll(name).forEach(function (element) {
      element.removeAttribute("readonly");
    })
    document.getElementsByName("btgrnoffice-" + idCity)[0].removeAttribute("hidden");

    document.getElementsByName("btednoffice-" + idCity)[0].setAttribute("hidden", "hidden");
  }

  updateList(idCity: any) {
    this.cleanMessage();
    let name = "[date-city = '" + idCity + "']";
    document.querySelectorAll(name).forEach(function (element) {
      element.setAttribute("readonly", "readonly");
    });

    //console.log(this.List.find(t => t.idOffice == idOffice));

    this.cityService.updateCity(this.List.find(t => t.idCity == idCity))
      .subscribe(res => {
        document.getElementsByName("btednoffice-" + idCity)[0].removeAttribute("hidden");
        document.getElementsByName("btgrnoffice-" + idCity)[0].setAttribute("hidden", "hidden");
      }, err => this.error = err)

  }

  deptaName(fkIdDepartment: number) {
    return this.List2.find(u => u.idDepartment == fkIdDepartment).departmentName;
  }


}
